import i18next, { TOptions, StringMap } from "i18next";
import { TranslationKey, translationResources } from "translations";
import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  FC,
  useRef,
} from "react";
import moment from "moment";
import "moment/locale/de";

interface ITranslationContext {
  t: (key: TranslationKey, options?: TOptions<StringMap>) => string;
}

const TranslationContext = createContext<ITranslationContext>({
  t: (key) => key,
});

export const TranslationProvider: FC = (props) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const instanceRef = useRef(i18next.createInstance());

  useEffect(() => {
    init();
  }, []);

  async function init() {
    try {
      const locale = navigator.language || "en_US";
      const language = locale.substring(0, 2);

      await instanceRef.current.init({
        lng: language,
        fallbackLng: "en",
        resources: translationResources,
      });

      moment.locale(locale);
      setIsInitialized(true);
    } catch (error) {
      // TODO: log error!
    }
  }

  const context: ITranslationContext = {
    t: (key: TranslationKey, options?: TOptions<StringMap>) => {
      return instanceRef.current.t(key, options);
    },
  };

  return (
    <TranslationContext.Provider value={context}>
      {isInitialized ? props.children : undefined}
    </TranslationContext.Provider>
  );
};

export function useTranslation() {
  return useContext(TranslationContext);
}
